<script>
    import { Circle } from "svelte-loading-spinners";
</script>

<div class="dialog-overlay">
    <Circle color="#FFFFFF"></Circle>
</div>

<style>
    .dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
</style>